module.exports = __webpack_public_path__ + "img/avatar3.7dbc8a87.png";